// 시안 v6 「AI 모델 설정」(pg-model · renderModel). 계약 §10 — GET/PUT /model, 대표 전용.
import { useEffect, useState } from "react";
import AdminGate from "../../v6common/AdminGate";
import { errorText } from "../../inquiry/v6Api";
import { showToast } from "../../../utill/utill";
import { getModel, saveModel } from "./api";
import { STYLES, OPTIONS, DEFAULT_NAME, pickForm, pct, sec, cnt, stamp } from "./view";
import "../../../admin_styles/inquiry_renewal.css";
import "../../../admin_styles/admin_v6.css";

function StatusPanel({ status, checkedAt }) {
    const s = status || {};
    return (
        <div className="panel">
            <div className="pn-h"><h3>모델 운영 현황</h3><span className="hint">최근 30일</span><span className="sp"></span>
                <span className="hint">상태 <b style={{ color: "#15803d" }}>정상</b> · 마지막 확인 {checkedAt}</span></div>
            <div className="mstat">
                <div><span>재질문율</span><b>{pct(s.requery_rate)}</b><small>로그로 산출 · 낮을수록 좋음</small></div>
                <div><span>평균 응답시간</span><b>{sec(s.avg_first_response_sec)}</b><small>질문 후 첫 답변까지</small></div>
                <div><span>처리 문의</span><b>{cnt(s.completed_inquiries_30d)}</b><small>완료 상태 기준</small></div>
                <div><span>모델 가동률</span><b>{pct(s.uptime_rate)}</b><small>API 정상 응답 비율</small></div>
            </div>
        </div>
    );
}

function ModelTable() {
    return (
        <div className="panel mt"><div className="pn-h"><h3>사용 모델</h3></div><div className="pn">
            <table className="tbl mtbl"><thead><tr><th style={{ width: 110 }}>용도</th><th style={{ width: 200 }}>모델</th><th style={{ width: 100 }}>상태</th><th>설명</th></tr></thead><tbody>
                <tr><td className="k">답변 생성</td><td><b>GPT-4o-mini</b><span className="sub">OpenAI</span></td><td><span className="st-on">사용 중</span></td><td>지식베이스 문서와 FAQ에서 찾은 내용으로 가맹점주 질문에 답합니다. 한국어·中文 답변. 응답이 빠르고 비용이 낮은 경량 모델입니다.</td></tr>
                <tr><td className="k">음성 인식</td><td><b>Soniox</b><span className="sub">한국어·중국어 통합 STT</span></td><td><span className="st-on">사용 중</span></td><td>한국어·중국어 음성을 글자로 바꿔 입력합니다. 포스·키오스크 용어는 커스텀 어휘로 등록합니다. 답변 음성 출력(TTS)은 이번 단계에서 제외합니다.</td></tr>
            </tbody></table>
        </div></div>
    );
}

function ModelBody() {
    const [loaded, setLoaded] = useState(null); // { model|null, checkedAt }
    const [loadErr, setLoadErr] = useState("");
    const [form, setForm] = useState(null);
    const [dirty, setDirty] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let alive = true;
        getModel()
            .then((m) => { if (alive) { setLoaded({ model: m, checkedAt: stamp() }); setForm(pickForm(m)); } })
            .catch((e) => { if (alive) setLoadErr(errorText(e)); });
        return () => { alive = false; };
    }, []);

    if (loadErr) return <div className="actorbar" style={{ marginTop: 24 }}><i className="fa-solid fa-triangle-exclamation"></i>{loadErr}</div>;
    if (!form) return <div className="empty">불러오는 중…</div>;

    const set = (k, v) => { setForm((f) => ({ ...f, [k]: v })); setDirty(true); };
    const style = STYLES.find((s) => s.code === form.response_style) || STYLES[0];

    const save = async () => {
        setSaving(true);
        try {
            const body = loaded.model ? { ...form } : { name: DEFAULT_NAME, ...form };
            const saved = await saveModel(body);
            setLoaded((l) => ({ ...l, model: { ...(l.model || {}), ...saved } }));
            setDirty(false);
            showToast("AI 모델 설정을 저장했습니다. 다음 대화부터 적용됩니다.", "success");
        } catch (e) {
            showToast(errorText(e), "error");
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <StatusPanel status={loaded.model?.status} checkedAt={loaded.checkedAt} />
            <ModelTable />
            <div className="cols2 mt">
                <div className="fsec" style={{ margin: 0 }}><h3><i className="fa-solid fa-comments"></i>응답 스타일</h3>
                    <div className="fld"><label htmlFor="mdStyle">응답 톤앤매너</label>
                        <select className="sel" id="mdStyle" style={{ width: "100%" }} value={form.response_style} onChange={(e) => set("response_style", e.target.value)}>
                            {STYLES.map((s) => <option key={s.code} value={s.code}>{s.label}</option>)}
                        </select>
                        <div className="help">챗봇 답변의 말투를 정합니다. 바꾸면 다음 대화부터 적용됩니다.</div></div>
                    <div className="fld"><label>미리보기</label><div className="chat" style={{ maxHeight: "none" }}>
                        <div className="bub u">영수증 용지 다 떨어졌어요</div><div className="bub b" id="mdPrev">{style.preview}</div></div></div>
                </div>
                <div className="fsec" style={{ margin: 0 }}><h3><i className="fa-solid fa-sliders"></i>응답 품질 설정</h3>
                    {OPTIONS.map((o) => (
                        <div className="opt" key={o.key}><div><b>{o.title}</b><small>{o.sub}</small></div><span className="sp"></span>
                            <button type="button" className={`tgl ${form[o.key] ? "on" : ""}`} aria-label={o.title} aria-pressed={!!form[o.key]} onClick={() => set(o.key, !form[o.key])}></button></div>
                    ))}
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 12, marginTop: 16 }}>
                {dirty && <span className="help" style={{ color: "var(--tx3)", fontSize: 12 }}>저장하지 않은 변경이 있습니다</span>}
                <button type="button" className="btn btn-pri" id="mdSave" disabled={saving} onClick={save}><i className="fa-solid fa-floppy-disk"></i>설정 저장</button>
            </div>
        </>
    );
}

export default function ModelPage({ go }) {
    return (
        <main className="inq-r">
            <div className="top">
                <div><h1>AI 모델 설정</h1><p>답변 모델과 음성 인식 모델, 응답 스타일을 관리합니다</p></div>
                <div className="top-act"><span className="pill-ok">사용 모델 <b>GPT-4o-mini</b></span></div>
            </div>
            <AdminGate ownerOnly>{() => <ModelBody />}</AdminGate>
        </main>
    );
}
